import './IconButton.css'

/**
 * Button komponent der kan bruges til at lave forskellige typer knapper
 * @param {function} onClick - Funktion der kaldes når knappen klikkes
 * @param {React.ReactNode} icon - Iconet der vises på knappen
 * @param {object} style - Custom inline styles der skal anvendes på knappen
 * @param {string} className - Custom CSS klasse der skal tilføjes til knappen
 */
const IconButton = ({
    onClick, 
    icon,
    style = {},
    variant = '',
    disabled = false,
}) => {
    let buttonStyle = {}
    if (variant === 'outlined') {
        buttonStyle = {
            '--icon-button-color': 'var(--primary-font-color)',
        }
    }
    return (
        <button 
            className={`icon-button ${variant}`.trim()}
            onClick={onClick}
            style={style}
            disabled={disabled}
        >
            {icon}
        </button>
    )
}

export default IconButton